import * as fetch from 'isomorphic-fetch';

interface IOptions {
  url: string;
  method?: string;
  data?: any;
  headers?: any;
  mode?: string;
  shopDomain?: string;
  noChecklogin?: boolean;
};

const request = async (options: IOptions) => {
  let dataTemp = '';
  if(options.method && typeof options.method === 'string' && options.method.toLowerCase() === 'post') {
    if(typeof options.data === 'string') {
      dataTemp = options.data;
    } else if(options.data) {
      for(const item of Object.keys(options.data)) {
        dataTemp += `${item}=${options.data[item]}&`;
      }
      dataTemp = dataTemp.substring(0, dataTemp.length-1);
    }
    try {
      const r: any = await fetch(options.url, {
        body: dataTemp,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
          ...(options.headers || {})
        },
        method: 'POST',
        mode: 'cors'
      }).then(response => response.json());

      // 如果是英文版，并且没有开通英文店铺，跳转回中文首页
      checkAndJumpToMain(options, r)

      // 如果没有登录
      if(!options.noChecklogin && (r.code === 100 || r.error_code === 100 || r.error_code === 57000)) {
        const loginComponent: any = (window as any).login;
        if(loginComponent) {
          loginComponent.show();
        }
        return {};
      }
      // 如果没有店铺id
      else if(r.error_code === 58000) {
        window.location.href = '/m/404/';
      } else if (r.error_code === 59000) {
        window.location.href = '/m/404/?c=1'
      } 
      else {
        return r;
      }
    } catch(err) {
      return {};
    }

  } else {
    if(options.data) {
      dataTemp = (options.url.indexOf('?') === -1 ? '?' : '&');
      for(const item of Object.keys(options.data)) {
        dataTemp += `${item}=${options.data[item]}&`;
      }
      dataTemp = dataTemp.substring(0, dataTemp.length-1);
    }
    try {
      const r: any = await fetch(options.url + dataTemp, {
        credentials: "include",
        headers: options.headers || {},
        mode: 'cors'
      }).then(response => response.json()); 
      // 如果是英文版，并且没有开通英文店铺，跳转回中文首页
      checkAndJumpToMain(options, r)
      if(!options.noChecklogin && (r.code === 100 || r.error_code === 100 || r.error_code === 57000)) {
        const loginComponent: any = (window as any).login;
        if(loginComponent) {
          loginComponent.show();
        }
        return {};
      } else {
        return r;
      }
    } catch(err) {
      return {};
    }
  }
}

function checkAndJumpToMain(option: IOptions, responseData: any) {
  if (option.url.indexOf('wshop/shop/shop-info') > -1 && option.data.lanType === 1 && responseData.data && responseData.data[0].is_cross_border !== '2') {
    window.location.href = '/m/';
  }
}

export default request;



// WEBPACK FOOTER //
// ./src/utils/request.ts